module.exports = __webpack_public_path__ + "img/PS8.9260948d.png";